<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ActiveFilterChip from './Filters/v3/ActiveFilterChip.vue';

const props = defineProps({
  venues: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const showMenu = ref(false);
const activeFilterType = ref('');

const venueOptions = computed(() =>
  props.venues.map(venue => ({
    id: venue.id,
    name: venue.name,
    type: 'venues',
  }))
);

const selectedVenueName = computed(() => {
  const venue = props.venues.find(item => item.id === props.modelValue);
  return venue?.name || t('BUZZ_REPORTS.FILTER_DROPDOWN_LABEL');
});

const openDropdown = filterType => {
  activeFilterType.value = filterType;
  showMenu.value = !showMenu.value;
};

const closeDropdown = () => {
  showMenu.value = false;
  activeFilterType.value = '';
};

const selectVenue = item => {
  emit('update:modelValue', item.id);
  closeDropdown();
};
</script>

<template>
  <div class="flex flex-col w-full gap-3 lg:flex-row print:hidden">
    <ActiveFilterChip
      :id="modelValue"
      filled
      menu-align="start"
      icon="i-lucide-map-pin"
      :name="selectedVenueName"
      type="venues"
      :options="venueOptions"
      :active-filter-type="activeFilterType"
      :show-menu="showMenu"
      :placeholder="t('BUZZ_REPORTS.SEARCH_VENUE')"
      :show-clear-filter="false"
      enable-search
      @toggle-dropdown="openDropdown"
      @close-dropdown="closeDropdown"
      @add-filter="selectVenue"
    />
  </div>
</template>
